import {NgModule} from '@angular/core';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSortModule} from '@angular/material/sort';
import {MatToolbarModule} from '@angular/material/toolbar';
import {AddressDialogComponent} from '../relation/dialogs/address-dialog.component';
import {CommunicationDialogComponent} from '../relation/dialogs/communication-dialog.component';
import {RelationArticleDialogComponent} from '../relation/dialogs/relation-article-dialog.component';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NgxPermissionsModule} from 'ngx-permissions';
import {CreateRelationDialogComponent} from '@core/dialog/create-relation-dialog/create-relation-dialog.component';
import {PaymentDialogComponent} from '@core/dialog/payment-dialog/payment-dialog.component';
import {BpmcalcDialogComponent} from '@core/dialog/bpmcalc-dialog/bpmcalc-dialog.component';
import {DirtyDialogComponent} from '@core/dialog/dirty-dialog/dirty-dialog.component';
import {SendEmailDialogComponent} from '@core/dialog/send-email-dialog/send-email-dialog.component';
import {YesNoDialogComponent} from '@core/dialog/yes-no-dialog/yes-no-dialog.component';
import {CoreRelationComponent} from '@core/dialog/payment-dialog/relation.component';
import {SearchCarDialogComponent} from '@core/dialog/search-car-dialog/search-car-dialog.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {
  ManufacturerSelectDialogComponent
} from "@core/dialog/manufacturer-select-dialog/manufacturer-select-dialog.component";
import {
  OfferRelationSelectDialogComponent
} from "@core/dialog/offer-relation-select-dialog/offer-relation-select-dialog.component";
import {InfoDialogComponent} from "@core/dialog/info-dialog/info-dialog.component";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelActionRow,
  MatExpansionPanelDescription
} from "@angular/material/expansion";
import {RelationSelectDialogComponent} from "@core/dialog/relation-select-dialog/relation-select-dialog.component";
import {DeviceSelectDialogComponent} from "@core/dialog/device-select-dialog/device-select-dialog.component";

const matComponents = [
  MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatSortModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTableModule,
  MatTabsModule
];

export const dialogs = [
  AddressDialogComponent,
  CreateRelationDialogComponent,
  BpmcalcDialogComponent,
  CommunicationDialogComponent,
  DirtyDialogComponent,
  PaymentDialogComponent,
  RelationArticleDialogComponent,
  SearchCarDialogComponent,
  SendEmailDialogComponent,
  ManufacturerSelectDialogComponent,
  RelationSelectDialogComponent,
  DeviceSelectDialogComponent,
  OfferRelationSelectDialogComponent,
  YesNoDialogComponent,
  InfoDialogComponent
];

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ...matComponents,
        NgxPermissionsModule.forChild(),
        MatAccordion,
        MatExpansionPanelActionRow,
        MatExpansionPanel,
        MatExpansionPanelDescription,
        CoreRelationComponent,
        ...dialogs
    ],
    exports: [
        ...matComponents
    ]
})
export class CoreModule {
}
